import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Brand, InitialState } from '@/modules/settings/brands/types/types.ts'

const initialState: InitialState = {
  selected: undefined,
  isOpenModal: false,
  isDeleteModalOpen: false
}

const brandsSlice = createSlice({
  name: 'brands',
  initialState,
  reducers: {
    setSelected(state, action: PayloadAction<Brand | undefined>) {
      state.selected = action.payload
    },
    setOpenModal: (state, action: PayloadAction<boolean>) => {
      state.isOpenModal = action.payload
    },
    setDeleteOpenModal: (state, action: PayloadAction<boolean>) => {
      state.isDeleteModalOpen = action.payload
    }
  }
})

export const brandsActions = brandsSlice.actions

export const { reducer: brandsReducer } = brandsSlice
